import * as Yup from 'yup';

import { createPhoneNumberValidation } from '@ui';

export const loginPhoneNumValidations = () => {
  return createPhoneNumberValidation('mobile', 'country');
};

export const regUserDetailsValidations = () => {
  return Yup.object()
    .shape({
      fullName: Yup.string()
        .matches(/^[a-zA-Z][a-zA-Z\s]*$/, 'Only alphabets and space are allowed')
        .min(2, 'Name too Short!')
        .max(60, 'Name too Long!')
        .required('Required')
    })
    .concat(createPhoneNumberValidation('mobile', 'country'));
};

export const otpValidations = () => {
  return Yup.object().shape({
    otp: Yup.string()
      .required()
      .matches(/^[0-9]+$/, 'Must be only digits')
      .min(6, 'Must be exactly 6 digits')
      .max(6, 'Must be exactly 6 digits')
  });
};
